import { Container, Row, Col } from "react-bootstrap";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
import github from "../assets/img/github.svg";


export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center d-flex align-items-center justify-content-center">
          <Col size={12} sm={6} className="text-center text-sm-end mt-5 d-flex align-items-center justify-content-center flex-column">
            <div className="social-icon">
              <a href="https://github.com/Ajayprajapati786" target="_blank" rel="noopener noreferrer"><img src={github} alt="Icon" /></a>
              {/* <a href="https://www.linkedin.com/in/ajay-prajapati-3282a01b7/" target="_blank" rel="noopener noreferrer"><img src={navIcon1} alt="Icon" /></a> */}
              {/* <a href="https://drive.google.com/file/d/1wN9ESRiyCmt6DIYYH4QmVqShjAs-FZt9/view?usp=sharing" target="_blank" rel="noopener noreferrer"><img src={navIcon2} alt="Icon" /></a> */}
              <a href="https://twitter.com/AjayPra786" target="_blank" rel="noopener noreferrer"><img src={navIcon3} alt="Icon" /></a>
            </div>
            <p><a href="https://youtu.be/hYv6BM2fWd8" target="_blank" rel="noopener noreferrer" style={{textDecoration:"none"}}>Credit for this design</a></p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
